// extracted by mini-css-extract-plugin
export default {"cls1":"render-cls1___52b8cf5bc12650671c8","cls2":"render-cls2___4bb058922e74e57c8bc render-cls1___52b8cf5bc12650671c8"};